var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyOrders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 68,
    viewBox: "0 0 73 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 68,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 768,
    transform: "translate(-645 -292)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4988 13.3846L33.0536 8.69275C39.0584 6.99089 43.4968 9.71893 45.1111 16.0912L50.5785 37.6736C52.2192 44.1503 49.6439 48.7766 43.6391 50.4784L27.0843 55.1703C20.9826 56.8996 16.6642 54.2271 15.0234 47.7504L9.55602 26.168C7.94173 19.7957 10.3971 15.1139 16.4988 13.3846Z",
    fill: "url(#paint0_linear_1_3)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_1_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.791 19.2489L32.1112 16.0406C36.2174 14.8768 39.2523 16.7423 40.3562 21.0997L44.0948 35.8577C45.2167 40.2865 43.4557 43.45 39.3496 44.6137L28.0294 47.822C23.8571 49.0045 20.9041 47.1771 19.7822 42.7482L16.0435 27.9902C14.9397 23.6328 16.6187 20.4314 20.791 19.2489Z",
    fill: "#5F656D",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1_3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_1_3",
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 12.2284,
    width: 50,
    height: 52,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 18,
    y: 12.2284,
    width: 50,
    height: 52
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9999 37.9872V48.141C67.0004 49.2431 66.9164 50.3435 66.7489 51.4313C66.4854 53.3538 65.8594 55.201 64.9079 56.8637C64.4744 57.6662 63.9473 58.4081 63.3388 59.072C60.5422 61.7773 56.8344 63.1853 53.046 62.9807H33.9248C30.1424 63.1868 26.4406 61.7782 23.6529 59.072C23.037 58.4094 22.5028 57.6674 22.0629 56.8637C21.1057 55.1998 20.4661 53.3544 20.1801 51.4313C20.0299 50.3417 19.953 49.2421 19.9499 48.141V35.068C19.8784 32.5649 20.2254 30.0682 20.975 27.6923C21.356 26.5363 21.9378 25.4654 22.6905 24.5345C22.9272 24.2405 23.186 23.9672 23.4646 23.7174C25.883 21.7055 28.9301 20.728 32.0001 20.9791H39.0536C40.7234 20.9447 42.2985 20.1398 43.36 18.7719L45.6403 15.4374C46.7151 14.0163 48.3529 13.2009 50.0754 13.2291H54.9708C63.7573 13.2291 67 18.6835 67 27.9583V37.9839C67 37.985 67 37.9861 66.9999 37.9872Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9999 37.9872V48.141C67.0004 49.2431 66.9164 50.3435 66.7489 51.4313C66.4854 53.3538 65.8594 55.201 64.9079 56.8637C64.4744 57.6662 63.9473 58.4081 63.3388 59.072C60.5422 61.7773 56.8344 63.1853 53.046 62.9807H33.9248C30.1424 63.1868 26.4406 61.7782 23.6529 59.072C23.037 58.4094 22.5028 57.6674 22.0629 56.8637C21.1057 55.1998 20.4661 53.3544 20.1801 51.4313C20.0299 50.3417 19.953 49.2421 19.9499 48.141V35.068C19.8784 32.5649 20.2254 30.0682 20.975 27.6923C21.356 26.5363 21.9378 25.4654 22.6905 24.5345C22.9272 24.2405 23.186 23.9672 23.4646 23.7174C25.883 21.7055 28.9301 20.728 32.0001 20.9791H39.0536C40.7234 20.9447 42.2985 20.1398 43.36 18.7719L45.6403 15.4374C46.7151 14.0163 48.3529 13.2009 50.0754 13.2291H54.9708C63.7573 13.2291 67 18.6835 67 27.9583V37.9839C67 37.985 67 37.9861 66.9999 37.9872Z",
    fill: "#5F656D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9999 37.9872H65.9999C65.9999 37.9626 66.0008 37.9381 66.0026 37.9137L66.9999 37.9872ZM66.9999 48.141L65.9999 48.1414V48.141H66.9999ZM66.7488 51.4313L65.7581 51.2955C65.7589 51.2901 65.7597 51.2846 65.7605 51.2791L66.7488 51.4313ZM64.9079 56.8637L64.028 56.3885C64.0319 56.3813 64.0359 56.3741 64.0399 56.367L64.9079 56.8637ZM63.3388 59.072L64.076 59.7476C64.0625 59.7624 64.0485 59.7768 64.0341 59.7907L63.3388 59.072ZM53.046 62.9807V61.9807C53.064 61.9807 53.082 61.9811 53.0999 61.9821L53.046 62.9807ZM33.9248 62.9807L33.8703 61.9821C33.8885 61.9811 33.9066 61.9807 33.9248 61.9807V62.9807ZM23.6529 59.072L22.9563 59.7895C22.944 59.7776 22.932 59.7653 22.9203 59.7528L23.6529 59.072ZM22.0629 56.8637L22.9297 56.3651C22.9332 56.3712 22.9367 56.3774 22.9401 56.3836L22.0629 56.8637ZM20.1801 51.4313L19.1909 51.5785L19.1894 51.5679L20.1801 51.4313ZM19.95 48.141L18.95 48.1437V48.141H19.95ZM19.95 35.068L20.9495 35.0394C20.9498 35.0489 20.95 35.0585 20.95 35.068H19.95ZM20.975 27.6923L20.0213 27.3914L20.0253 27.3793L20.975 27.6923ZM22.6905 24.5345L23.4695 25.1615L23.4681 25.1632L22.6905 24.5345ZM23.4646 23.7174L22.7969 22.973C22.8061 22.9647 22.8155 22.9566 22.825 22.9486L23.4646 23.7174ZM32.0001 20.9791V21.9791C31.9729 21.9791 31.9457 21.978 31.9186 21.9758L32.0001 20.9791ZM39.0536 20.9791L39.0742 21.9789C39.0673 21.9791 39.0604 21.9791 39.0536 21.9791V20.9791ZM43.36 18.7719L44.1854 19.3364C44.1741 19.3529 44.1623 19.3691 44.15 19.3849L43.36 18.7719ZM45.6403 15.4374L44.8148 14.8729C44.8238 14.8597 44.8331 14.8468 44.8427 14.8341L45.6403 15.4374ZM50.0754 13.2291V14.2291C50.0699 14.2291 50.0645 14.229 50.059 14.229L50.0754 13.2291ZM67 37.9839L66 37.9938V37.9839H67ZM67.9999 37.9872V48.141H65.9999V37.9872H67.9999ZM67.9999 48.1406C68.0004 49.2937 67.9125 50.4451 67.7372 51.5836L65.7605 51.2791C65.9203 50.2418 66.0003 49.1925 65.9999 48.1414L67.9999 48.1406ZM67.7396 51.5671C67.4589 53.615 66.7918 55.5849 65.7758 57.3604L64.0399 56.367C64.9269 54.8171 65.5118 53.0926 65.7581 51.2955L67.7396 51.5671ZM65.7877 57.3389C65.3157 58.2129 64.7408 59.0223 64.076 59.7476L62.6016 58.3963C63.1537 57.7939 63.6332 57.1195 64.028 56.3885L65.7877 57.3389ZM64.0341 59.7907C61.0433 62.6838 57.0662 64.1993 52.9921 63.9792L53.0999 61.9821C56.6026 62.1713 60.0411 60.8707 62.6436 58.3532L64.0341 59.7907ZM53.046 63.9807H33.9248V61.9807H53.046V63.9807ZM33.9792 63.9792C29.9103 64.201 25.9384 62.6843 22.9563 59.7895L24.3494 58.3545C26.9428 60.872 30.3746 62.1727 33.8703 61.9821L33.9792 63.9792ZM22.9203 59.7528C22.2475 59.0287 21.6649 58.2192 21.1857 57.3439L22.9401 56.3836C23.3408 57.1156 23.8266 57.79 24.3854 58.3912L22.9203 59.7528ZM21.1961 57.3623C20.1757 55.5886 19.4952 53.6237 19.191 51.5785L21.1692 51.2842C21.4371 53.0851 22.0358 54.8111 22.9297 56.3651L21.1961 57.3623ZM19.1894 51.5679C19.0331 50.4338 18.9531 49.2896 18.95 48.1437L20.9499 48.1383C20.9528 49.1947 21.0266 50.2495 21.1707 51.2948L19.1894 51.5679ZM18.95 48.141V35.068H20.95V48.141H18.95ZM18.9504 35.0965C18.8757 32.4825 19.238 29.8743 20.0214 27.3914L21.9287 27.9932C21.2129 30.262 20.8812 32.6474 20.9495 35.0394L18.9504 35.0965ZM20.0253 27.3793C20.4435 26.1105 21.0829 24.9322 21.9129 23.9057L23.4681 25.1632C22.7927 25.9986 22.2686 26.9622 21.9248 28.0053L20.0253 27.3793ZM21.9115 23.9074C22.1818 23.5717 22.4778 23.2591 22.7969 22.973L24.1323 24.4618C23.8943 24.6753 23.6726 24.9092 23.4695 25.1615L21.9115 23.9074ZM22.825 22.9486C25.4399 20.7733 28.7446 19.7095 32.0816 19.9825L31.9186 21.9758C29.1156 21.7465 26.3261 22.6377 24.1041 24.4862L22.825 22.9486ZM32.0001 19.9791H39.0536V21.9791H32.0001V19.9791ZM39.0329 19.9793C40.39 19.9514 41.6865 19.2972 42.5699 18.1588L44.15 19.3849C42.9104 20.9823 41.0568 21.938 39.0742 21.9789L39.0329 19.9793ZM42.5345 18.2074L44.8148 14.8729L46.4657 16.0019L44.1854 19.3364L42.5345 18.2074ZM44.8427 14.8341C46.1023 13.1689 48.0376 12.1956 50.0918 12.2292L50.059 14.229C48.6683 14.2062 47.328 14.8638 46.4378 16.0406L44.8427 14.8341ZM50.0754 12.2291H54.9708V14.2291H50.0754V12.2291ZM54.9708 12.2291C59.585 12.2291 62.9303 13.6741 65.0778 16.5123C67.1814 19.2925 68 23.2384 68 27.9583H66C66 23.4034 65.1973 19.9848 63.4829 17.719C61.8124 15.5113 59.1431 14.2291 54.9708 14.2291V12.2291ZM68 27.9583V37.9839H66V27.9583H68ZM67.9999 37.974C68.0002 38.0031 67.9993 38.032 67.9972 38.0607L66.0026 37.9137C66.0006 37.9401 65.9998 37.9669 66 37.9938L67.9999 37.974Z",
    fill: "url(#paint1_linear_1_3)",
    mask: "url(#path-3-outside-1_1_3)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_1_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9975 52.0421H55.6794C56.7539 52.0421 57.625 51.1226 57.625 49.9884C57.625 48.8541 56.7539 47.9347 55.6794 47.9347H31.8092C31.2298 47.9416 30.6872 48.2361 30.3448 48.7296C30.0471 49.0969 29.897 49.5723 29.9264 50.0546C29.9427 50.6034 30.1665 51.1224 30.5477 51.4958C30.929 51.8692 31.4361 52.0659 31.9557 52.0421H31.9975Z",
    fill: "url(#paint2_linear_1_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5091 48.8437L30.5049 48.8498L30.5002 48.8556C30.2348 49.183 30.0996 49.6088 30.126 50.0424L30.1261 50.0424L30.1263 50.0487C30.1411 50.5474 30.3445 51.0168 30.6877 51.3529C31.0305 51.6886 31.4839 51.8635 31.9465 51.8423L31.9465 51.8421H31.9557H31.9975H55.6794C56.6334 51.8421 57.425 51.0225 57.425 49.9884C57.425 48.9543 56.6334 48.1347 55.6794 48.1347H31.8105C31.2989 48.1412 30.816 48.4013 30.5091 48.8437Z",
    stroke: "white",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bd_1_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2405 40.3259C38.7532 40.8546 38.7532 41.7099 39.2405 42.237C39.4842 42.5014 39.7996 42.6429 40.1293 42.6429C40.4447 42.6429 40.76 42.5185 41.0037 42.237L43.5553 39.4862L46.1069 42.237C46.3506 42.5014 46.666 42.6429 46.9957 42.6429C47.3111 42.6429 47.6408 42.5014 47.8845 42.237C48.3718 41.7099 48.3718 40.8546 47.8845 40.3104L45.3329 37.558L47.8845 34.7886C48.3718 34.2615 48.3718 33.3907 47.8845 32.862C47.3971 32.3317 46.6087 32.3317 46.1069 32.862L43.5553 35.6283L41.0181 32.862C40.5163 32.3317 39.7279 32.3317 39.2405 32.862C38.7532 33.3907 38.7532 34.2615 39.2405 34.7886L41.7921 37.558L39.2405 40.3259Z",
    fill: "url(#paint3_linear_1_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3874 42.1012L39.3876 42.1014C39.5961 42.3277 39.8594 42.4429 40.1293 42.4429C40.3894 42.4429 40.6486 42.3416 40.8525 42.1061L40.8524 42.106L40.8571 42.101L43.4087 39.3502L43.5553 39.1921L43.702 39.3502L46.2536 42.101L46.254 42.1014C46.4625 42.3277 46.7258 42.4429 46.9957 42.4429C47.2526 42.4429 47.5298 42.3267 47.7374 42.1014L47.7376 42.1012C48.1527 41.6523 48.1559 40.9146 47.7366 40.445L45.1862 37.694L45.0605 37.5585L45.1858 37.4225L47.7374 34.6531L47.7376 34.6528C48.154 34.2024 48.1543 33.4498 47.7374 32.9975L47.7372 32.9973C47.3305 32.5548 46.6771 32.5513 46.2531 32.9985L43.7023 35.7639L43.5549 35.9237L43.4079 35.7635L40.8718 32.9984C40.4478 32.5513 39.7945 32.5549 39.3878 32.9973L39.3876 32.9975C38.9707 33.4498 38.971 34.2024 39.3874 34.6528L39.3876 34.6531L41.9392 37.4225L42.0641 37.5581L41.9392 37.6936L39.3876 40.4615C38.9707 40.9137 38.971 41.6508 39.3874 42.1012Z",
    stroke: "url(#paint4_linear_1_3)",
    strokeWidth: 0.4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_3",
    x: 0.71283,
    y: 0.701336,
    width: 58.7135,
    height: 62.4723,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_1_3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1_3",
    x: 3.9408,
    y: -2.77162,
    width: 79.0592,
    height: 81.7721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_1_3",
    x: 14.9228,
    y: 32.9347,
    width: 57.7022,
    height: 34.1094,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807843 0 0 0 0 0.847059 0 0 0 0 0.894118 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1_3",
    result: "effect2_dropShadow_1_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bd_1_3",
    x: 23.875,
    y: 17.4643,
    width: 39.375,
    height: 40.1786,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807843 0 0 0 0 0.847059 0 0 0 0 0.894118 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1_3",
    result: "effect2_dropShadow_1_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3",
    x1: 41.6243,
    y1: 18.5008,
    x2: 24.0939,
    y2: 77.7882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E757B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_3",
    x1: 59.5089,
    y1: 19.0269,
    x2: 27.431,
    y2: 56.5907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_3",
    x1: 31.8868,
    y1: 48.6767,
    x2: 61.3537,
    y2: 55.1534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_3",
    x1: 39.5397,
    y1: 34.3023,
    x2: 49.9842,
    y2: 34.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_3",
    x1: 46.7577,
    y1: 33.6501,
    x2: 40.1729,
    y2: 41.1617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 768,
    fill: "white",
    transform: "translate(-645 -292)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyOrders);
export default __webpack_public_path__ + "static/media/empty-orders.eff14c5c04c41c92917679476a864132.svg";
export { ForwardRef as ReactComponent };